import { render, staticRenderFns } from "./ChargeItem.vue?vue&type=template&id=9b0d8e8c&scoped=true&"
import script from "./ChargeItem.vue?vue&type=script&lang=js&"
export * from "./ChargeItem.vue?vue&type=script&lang=js&"
import style0 from "./ChargeItem.vue?vue&type=style&index=0&id=9b0d8e8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0d8e8c",
  null
  
)

export default component.exports